import React, { useEffect, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebaseConfig'; // Firebase App をインポート
import '../styles/LinkPreview.css';

const functions = getFunctions(app, 'asia-northeast2');
const getLinkPreview = httpsCallable(functions, 'getLinkPreview');

const LinkPreviewComponent = ({ url }) => {
  const [previewData, setPreviewData] = useState(null);

  useEffect(() => {
    const fetchPreview = async () => {
      try {
        const result = await getLinkPreview({ url });
        setPreviewData(result.data);
      } catch (error) {
        console.error('Error fetching link preview:', error.message);
      }
    };

    fetchPreview();
  }, [url]);

  if (!previewData) {
    return null;
  }

  return (
<div className="link-preview">
  {previewData.image && (
    <img
      src={previewData.image}
      alt="Preview"
      className="link-preview-image"
    />
  )}
  <div className="link-preview-details">
    <a href={previewData.url} target="_blank" rel="noopener noreferrer">
      <h4 className="link-preview-title">{previewData.title}</h4>
    </a>
    <p className="link-preview-description">{previewData.description}</p>
  </div>
</div>

  );
};

export default LinkPreviewComponent;
